export {RefreshInfoPopoverConnect as default} from './RefreshInfoPopover.connect';
